
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h7nb4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lNvN4 = parcelRequire("lNvN4");


var $4fGOw = parcelRequire("4fGOw");

const $387adc567339a7f4$export$90ff537b0999afb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFileState(id, t0) {
    const $ = (0, $bDgLe.c)(15);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: t2, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const skipRemote = t2 === undefined ? false : t2;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    let t3;
    if ($[2] !== id) {
        t3 = (state)=>state.files[id];
        $[2] = id;
        $[3] = t3;
    } else t3 = $[3];
    const fileState = (0, $4fGOw.useMediaStore)(t3);
    const initialFileStateRef = (0, $cozmU.useRef)(initialFileState);
    let t4;
    let t5;
    if ($[4] !== collectionName || $[5] !== fileState || $[6] !== id || $[7] !== includeHashForDuplicateFiles || $[8] !== mediaClient || $[9] !== occurrenceKey || $[10] !== skipRemote) {
        t4 = ()=>{
            if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
                initialFileState: initialFileStateRef.current,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            });
        };
        t5 = [
            id,
            mediaClient,
            collectionName,
            occurrenceKey,
            skipRemote,
            fileState,
            includeHashForDuplicateFiles
        ];
        $[4] = collectionName;
        $[5] = fileState;
        $[6] = id;
        $[7] = includeHashForDuplicateFiles;
        $[8] = mediaClient;
        $[9] = occurrenceKey;
        $[10] = skipRemote;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = fileState ?? initialFileState;
    let t7;
    if ($[13] !== t6) {
        t7 = {
            fileState: t6
        };
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : function useFileState(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const fileState = (0, $4fGOw.useMediaStore)((state)=>state.files[id]);
    // Capture initialFileState as a ref so it's a stable one-time SSR seed that
    // doesn't affect the useEffect dependency array. Including it directly would
    // cause repeated unsubscribe/resubscribe cycles whenever the caller passes a
    // new (unstabilized) object reference — each cycle fires getFileState before
    // the store is populated.
    const initialFileStateRef = (0, $cozmU.useRef)(initialFileState);
    (0, $cozmU.useEffect)(()=>{
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            initialFileState: initialFileStateRef.current,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState ?? initialFileState
    };
};
module.exports["useFileState"] = $387adc567339a7f4$export$90ff537b0999afb;

});

parcelRegister("7ZjkB", function(module, exports) {

var $3A0tH = parcelRequire("3A0tH");

const $12a390f126c52759$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new (0, $3A0tH.CommonMediaClientError)(error?.reason || 'unknown-reason', error?.metadata, error?.innerError);
};
module.exports["toCommonMediaClientError"] = $12a390f126c52759$export$a5db89cfc88eff9;

});

parcelRegister("4bGyn", function(module, exports) {

var $2tAB1 = parcelRequire("2tAB1");


var $6wYuL = parcelRequire("6wYuL");

const $7abb76fb4efee4c6$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [(0, $6wYuL.mediaBlobUrlIdentifier)]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = (0, $2tAB1.objectToQueryString)(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};
module.exports["addFileAttrsToUrl"] = $7abb76fb4efee4c6$export$e51a8146182600b8;

});

parcelRegister("2tAB1", function(module, exports) {
const $302cdd89ced30825$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
module.exports["objectToQueryString"] = $302cdd89ced30825$export$89a7e74069fbb7af;

});

parcelRegister("3e8oF", function(module, exports) {

var $je5JP = parcelRequire("je5JP");


var $4n1J4 = parcelRequire("4n1J4");

const $6d6ebabd8011869e$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[(0, $4n1J4.SupportedImageMetaTag).Orientation]) {
        const tagValue = tags[(0, $4n1J4.SupportedImageMetaTag).Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $4n1J4.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $6d6ebabd8011869e$export$67689507e8404821(file) {
    const tags = await (0, $je5JP.readImageMetaTags)(file);
    return $6d6ebabd8011869e$var$getOrientationFromTags(tags);
}
module.exports["getOrientation"] = $6d6ebabd8011869e$export$67689507e8404821;

});

parcelRegister("je5JP", function(module, exports) {

var $lFcXW = parcelRequire("lFcXW");


var $4IlAI = parcelRequire("4IlAI");


var $7kpm3 = parcelRequire("7kpm3");


var $4n1J4 = parcelRequire("4n1J4");

async function $63ab4f0fc6bf0709$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $4n1J4.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $4IlAI.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $7kpm3.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $4n1J4.ImageType).JPEG) return await (0, $lFcXW.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}
module.exports["readImageMetaTags"] = $63ab4f0fc6bf0709$export$41982b5c7acb23c4;

});

parcelRegister("lFcXW", function(module, exports) {

var $4n1J4 = parcelRequire("4n1J4");

const { XResolution: $c25f01645762d82d$var$XResolution, YResolution: $c25f01645762d82d$var$YResolution } = (0, $4n1J4.SupportedImageMetaTag);
let $c25f01645762d82d$var$loadImage;

function $c25f01645762d82d$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$c25f01645762d82d$var$loadImage) {
            const module = await (parcelRequire("9XMvT"));
            $c25f01645762d82d$var$loadImage = module.default || module;
        }
        $c25f01645762d82d$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $c25f01645762d82d$var$XResolution || key === $c25f01645762d82d$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}
module.exports["readJPEGExifMetaData"] = $c25f01645762d82d$export$556b2ccec62d7f2a;

});

parcelRegister("4n1J4", function(module, exports) {
var $b9c1a9cc5ecd1c95$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $b9c1a9cc5ecd1c95$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $b9c1a9cc5ecd1c95$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    // none
    'top-right': 2,
    // flip horizontal
    'bottom-right': 3,
    // rotate 180
    'bottom-left': 4,
    // flip vertical
    'left-top': 5,
    // transpose
    'right-top': 6,
    // rotate 90
    'right-bottom': 7,
    // transverse
    'left-bottom': 8 // rotate 270
};
module.exports["ImageType"] = $b9c1a9cc5ecd1c95$export$48c85e6e32ef0825;
module.exports["SupportedImageMetaTag"] = $b9c1a9cc5ecd1c95$export$e369bb48cf33e564;
module.exports["ExifOrientation"] = $b9c1a9cc5ecd1c95$export$f6ea0c89fd7d156;

});

parcelRegister("9XMvT", function(module, exports) {

let $740f41841e0aae08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $740f41841e0aae08$var$load("jZpW9").then(()=>parcelRequire('fEeWF'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("4IlAI", function(module, exports) {

var $iE4ah = parcelRequire("iE4ah");


var $6tAXT = parcelRequire("6tAXT");

let $e61e27988ac2aa89$var$pngChunksExtract;

async function $e61e27988ac2aa89$export$5fb37736440fca6f(file) {
    if (!$e61e27988ac2aa89$var$pngChunksExtract) {
        const module = await (parcelRequire("7TUsv"));
        $e61e27988ac2aa89$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $iE4ah.fileToArrayBuffer)(file);
    const chunks = $e61e27988ac2aa89$var$pngChunksExtract(buffer);
    return await (0, $6tAXT.parsePNGChunks)(chunks);
}
module.exports["readPNGXMPMetaData"] = $e61e27988ac2aa89$export$5fb37736440fca6f;

});

parcelRegister("iE4ah", function(module, exports) {
function $b0b66ff88e801aa2$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
module.exports["fileToArrayBuffer"] = $b0b66ff88e801aa2$export$956310555b96755a;

});

parcelRegister("6tAXT", function(module, exports) {
async function $1a709ca03699d2bb$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
   * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
   * Order of every chunk is not guaranteed.
   * And both iTXt and pHYs are Ancillary chunks.
   */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
     * iTXt contains the useful XMP/XML string data of meta tags
     */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
     * Pixels per unit, X axis: 4 bytes (unsigned integer)
     * Pixels per unit, Y axis: 4 bytes (unsigned integer)
     * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
     */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}
module.exports["parsePNGChunks"] = $1a709ca03699d2bb$export$9185743fdd58ce45;

});

parcelRegister("7TUsv", function(module, exports) {

let $5c09770087093396$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c09770087093396$var$load("5ViqD").then(()=>parcelRequire('eOunc'));

});

parcelRegister("7kpm3", function(module, exports) {
function $1cae499d3986977a$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}
module.exports["parseXMPMetaData"] = $1cae499d3986977a$export$55c3bc9841b19de2;

});

parcelRegister("9vt4W", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cvZVo = parcelRequire("cvZVo");

var $7ZjkB = parcelRequire("7ZjkB");


var $4zScG = parcelRequire("4zScG");


var $h7nb4 = parcelRequire("h7nb4");


var $lNvN4 = parcelRequire("lNvN4");


var $79pFL = parcelRequire("79pFL");


var $9OT81 = parcelRequire("9OT81");


var $iDrrr = parcelRequire("iDrrr");


var $dUAp3 = parcelRequire("dUAp3");


var $kytx3 = parcelRequire("kytx3");


var $f6g62 = parcelRequire("f6g62");


var $dpCBK = parcelRequire("dpCBK");


var $1HXkd = parcelRequire("1HXkd");


var $a0nKQ = parcelRequire("a0nKQ");


var $2j3QG = parcelRequire("2j3QG");


var $bhs8k = parcelRequire("bhs8k");


var $fBaII = parcelRequire("fBaII");


var $550mF = parcelRequire("550mF");


var $27snD = parcelRequire("27snD");


var $9GwDf = parcelRequire("9GwDf");


var $japih = parcelRequire("japih");


var $aw7FB = parcelRequire("aw7FB");


var $lc10g = parcelRequire("lc10g");


var $9JswH = parcelRequire("9JswH");


var $a4SEC = parcelRequire("a4SEC");


var $bsb7s = parcelRequire("bsb7s");


var $cLvvT = parcelRequire("cLvvT");


var $eKuIE = parcelRequire("eKuIE");


var $lSL6v = parcelRequire("lSL6v");


var $fioVE = parcelRequire("fioVE");

// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $88a5d6d53a08a849$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $88a5d6d53a08a849$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source, initialFileState: initialFileState })=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const [status, setStatus] = (0, $cozmU.useState)('loading');
    const [error, setError] = (0, $cozmU.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $cozmU.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $cozmU.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $cozmU.useState)('not-resolved');
    const ssrReliabilityRef = (0, $cozmU.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $dUAp3.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isLoading) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $cozmU.useMemo)(()=>dimensions ? (0, $f6g62.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $fioVE.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $a0nKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $a4SEC.getSSRData)(identifier, resizeMode);
            if (ssrData?.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!ssrData?.dataURI) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    // When the relay/SSR-seed path provided a full pre-signed CDN asset
                    // URL, pass it through to getImageUrlSync as the base. That inserts
                    // the client's image-transform params before &wm-ari and preserves
                    // the backend's v2 CDN path, CloudFront signature and watermark
                    // anchors that a rebuilt /file/{id}/image/cdn URL cannot reproduce.
                    const seededCdnUrl = initialFileState && initialFileState.status !== 'error' ? initialFileState.previewCdnUrl : undefined;
                    // Only use the seeded CDN URL when CDN delivery is actually in use.
                    // isCDNEnabled() is false for path-based routing (and for isolated
                    // cloud / GCP), where the signed media-cdn URL is not served — there
                    // getImageUrlSync must build the URL on the product's own /media-api
                    // host instead.
                    const ssrSeededCdnUrl = seededCdnUrl && (0, $79pFL.isCDNEnabled)() && (0, $iDrrr.fg)('platform_media_ssr_data_seed') ? seededCdnUrl : undefined;
                    return (0, $fBaII.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs, ssrSeededCdnUrl);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $1HXkd.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions_0, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions_0,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview_0, setPreview] = (0, $cozmU.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $h7nb4.useFileState)(identifier.id, {
        initialFileState: initialFileState,
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $cvZVo.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $cozmU.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status !== 'error') {
            if (preview_0 || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview_0 && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $lSL6v.MediaFilePreviewError)('failed-processing'));
            } else if (!preview_0 && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $lSL6v.MediaFilePreviewError)('metadata-fetch', (0, $7ZjkB.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview_0,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (0, $a4SEC.getSSRData)(identifier, resizeMode)?.loadPromise;
        if (preview_0 && (0, $japih.isSSRDataPreview)(preview_0) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview_0,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $fioVE.useCurrentValueRef)(()=>{
        return (0, $bhs8k.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview_0) setUpfrontPreviewStatus('resolved');
        else if (!preview_0 && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $cLvvT.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview_0,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $fioVE.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $cozmU.useEffect)(()=>{
        const cachedPreview = (0, $a0nKQ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview_0 && cachedPreview && !(0, $cLvvT.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview_0 && !isBannedLocalPreview && localBinary && (0, $lc10g.isSupportedLocalPreview)(mediaType) && (0, $9OT81.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $2j3QG.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e_0)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e_0);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview_0 || (0, $cLvvT.isBigger)(preview_0.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $aw7FB.isSSRPreview)(preview_0)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview_0 && (0, $aw7FB.isSSRPreview)(preview_0) && !(0, $eKuIE.isWider)(preview_0.dimensions, dimensions) && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e_1)=>{
                const wrappedError = (0, $dpCBK.ensureMediaFilePreviewError)('preview-fetch', e_1);
                if (!preview_0) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview_0,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        (0, $a0nKQ.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $a0nKQ.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $cozmU.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $9GwDf.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $kytx3.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $japih.isSSRDataPreview)(failedPreview) || (0, $9GwDf.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $kytx3.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $kytx3.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview_0?.dataURI) return;
        const isLocal = (0, $550mF.isLocalPreview)(failedPreview);
        const isRemote = (0, $27snD.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error_0 = new (0, $bsb7s.ImageLoadError)(failedPreview?.source);
            (0, $a0nKQ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error_0);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview_0?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $cozmU.useCallback)((newPreview_0)=>{
        if (newPreview_0) {
            if ((0, $9GwDf.isSSRClientPreview)(newPreview_0) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $japih.isSSRDataPreview)(newPreview_0) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview_0.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview_0?.dataURI !== preview_0?.dataURI) return;
    }, [
        preview_0?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $9JswH.generateScriptProps)(identifier, preview_0?.dataURI, resizeMode, preview_0?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $iDrrr.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $iDrrr.fg)('media-perf-lazy-loading-optimisation')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $4zScG.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix') ? $88a5d6d53a08a849$var$DEFAULT_SSR_PREVIEW : preview_0,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};
module.exports["useFilePreview"] = $88a5d6d53a08a849$export$4eaebdef02112fe4;

});

parcelRegister("4zScG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $lNvN4 = parcelRequire("lNvN4");


var $kbsbM = parcelRequire("kbsbM");


var $lCARa = parcelRequire("lCARa");


var $LCmg6 = parcelRequire("LCmg6");

function $53479886ecc2e2a4$var$useCurrentValueRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
const $53479886ecc2e2a4$export$46fd859414de9d62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (id, t0)=>{
    const $ = (0, $bDgLe.c)(20);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const innerRef = (0, $cozmU.useRef)(null);
    const clientIdRef = (0, $cozmU.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[2] !== mediaClient || $[3] !== options.collectionName) {
        t2 = ()=>{
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy_with_auth")) mediaClient.getClientId(options.collectionName).then((clientId)=>{
                clientIdRef.current = clientId;
            }).catch($53479886ecc2e2a4$var$_temp);
        };
        t3 = [
            mediaClient,
            options.collectionName
        ];
        $[2] = mediaClient;
        $[3] = options.collectionName;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[6] !== createAnalyticsEvent || $[7] !== id || $[8] !== mediaClient || $[9] !== options.collectionName) {
        t4 = async ()=>{
            try {
                await mediaClient.file.registerCopyIntent(id, options.collectionName);
                createAnalyticsEvent((0, $lCARa.getCopyIntentSuccessPayload)(id));
            } catch (t5) {
                const err = t5;
                createAnalyticsEvent((0, $kbsbM.getCopyIntentErrorPayload)(err, id));
            }
        };
        $[6] = createAnalyticsEvent;
        $[7] = id;
        $[8] = mediaClient;
        $[9] = options.collectionName;
        $[10] = t4;
    } else t4 = $[10];
    const registerCopyIntentRef = $53479886ecc2e2a4$var$useCurrentValueRef(t4);
    let t5;
    if ($[11] !== registerCopyIntentRef) {
        t5 = (elem)=>{
            innerRef.current = elem;
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy")) elem?.addEventListener("contextmenu", ()=>{
                registerCopyIntentRef.current();
            });
        };
        $[11] = registerCopyIntentRef;
        $[12] = t5;
    } else t5 = $[12];
    const copyNodeRef = t5;
    let t6;
    if ($[13] !== registerCopyIntentRef) {
        t6 = (event)=>{
            const currentCopyTarget = innerRef.current;
            const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
            if (currentSelectionContainsNode) {
                registerCopyIntentRef.current();
                if ((0, $iDrrr.fg)("platform_media_cross_client_copy_with_auth")) {
                    const clientId_0 = clientIdRef.current;
                    const html = event.clipboardData?.getData("text/html");
                    if (html && html.includes("data-node-type=\"media") && clientId_0) {
                        const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId_0}"$2`);
                        event.clipboardData?.setData("text/html", modifiedHtml);
                    }
                }
            }
        };
        $[13] = registerCopyIntentRef;
        $[14] = t6;
    } else t6 = $[14];
    const onGlobalCopy = t6;
    let t7;
    let t8;
    if ($[15] !== onGlobalCopy) {
        t7 = ()=>{
            if ((0, $iDrrr.fg)("platform_media_cross_client_copy")) (0, $LCmg6.getDocument)()?.addEventListener("copy", onGlobalCopy);
            return ()=>(0, $LCmg6.getDocument)()?.removeEventListener("copy", onGlobalCopy);
        };
        t8 = [
            onGlobalCopy
        ];
        $[15] = onGlobalCopy;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[18] !== copyNodeRef) {
        t9 = {
            copyNodeRef: copyNodeRef
        };
        $[18] = copyNodeRef;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : (id, options = {})=>{
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const innerRef = (0, $cozmU.useRef)(null);
    const clientIdRef = (0, $cozmU.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $53479886ecc2e2a4$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $lCARa.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $kbsbM.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $cozmU.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $cozmU.useCallback)((event)=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) {
                const clientId_0 = clientIdRef.current;
                const html = event.clipboardData?.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId_0) {
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId_0}"$2`);
                    event.clipboardData?.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_media_cross_client_copy')) (0, $LCmg6.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $LCmg6.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};
function $53479886ecc2e2a4$var$_temp() {}
module.exports["useCopyIntent"] = $53479886ecc2e2a4$export$46fd859414de9d62;

});

parcelRegister("kbsbM", function(module, exports) {

var $dOxiJ = parcelRequire("dOxiJ");

const $e7672981c7c11579$var$getRequestErrorDetails = (err)=>{
    if ((0, $dOxiJ.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $e7672981c7c11579$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $dOxiJ.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$e7672981c7c11579$var$getRequestErrorDetails(error)
        }
    };
};
module.exports["getCopyIntentErrorPayload"] = $e7672981c7c11579$export$3ab52330b662b987;

});

parcelRegister("lCARa", function(module, exports) {
const $6286d594fdfca498$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};
module.exports["getCopyIntentSuccessPayload"] = $6286d594fdfca498$export$aacb463551da2e8f;

});

parcelRegister("LCmg6", function(module, exports) {
const $92acd99a6d98db3f$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};
module.exports["getDocument"] = $92acd99a6d98db3f$export$f65ca476c09acec0;

});

parcelRegister("kytx3", function(module, exports) {

var $1HXkd = parcelRequire("1HXkd");


var $bsb7s = parcelRequire("bsb7s");

const $1adb3602e9fdfc19$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...(0, $1HXkd.extractErrorInfo)(new (0, $bsb7s.ImageLoadError)(preview.source), metadataTraceContext)
    });
module.exports["createFailedSSRObject"] = $1adb3602e9fdfc19$export$768c370ed0dbaeb3;

});

parcelRegister("1HXkd", function(module, exports) {

var $6yIoR = parcelRequire("6yIoR");


var $j0wXN = parcelRequire("j0wXN");


var $ddylP = parcelRequire("ddylP");


var $bUXmc = parcelRequire("bUXmc");

const $252d8d374c58f1c1$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: (0, $bUXmc.getRenderErrorFailReason)(error),
        error: (0, $ddylP.getRenderErrorErrorReason)(error),
        errorDetail: (0, $j0wXN.getRenderErrorErrorDetail)(error),
        metadataTraceContext: metadataTraceContext ?? (0, $6yIoR.getErrorTraceContext)(error)
    };
};
module.exports["extractErrorInfo"] = $252d8d374c58f1c1$export$74aaf4784c2edb2c;

});

parcelRegister("6yIoR", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

const $f1db833fb09feb75$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
module.exports["getErrorTraceContext"] = $f1db833fb09feb75$export$29aa614726672b2e;

});

parcelRegister("j0wXN", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

const $f640d832b69a8a28$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
module.exports["getRenderErrorErrorDetail"] = $f640d832b69a8a28$export$9ccc5365d056da4b;

});

parcelRegister("ddylP", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

const $b0039434081fc47f$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
module.exports["getRenderErrorErrorReason"] = $b0039434081fc47f$export$88c61dcad53762da;

});

parcelRegister("bUXmc", function(module, exports) {
const $5273a5c86ebd43c8$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
module.exports["getRenderErrorFailReason"] = $5273a5c86ebd43c8$export$4af9d71992e89714;

});

parcelRegister("bsb7s", function(module, exports) {

var $lSL6v = parcelRequire("lSL6v");

const $85dae4facaf44a93$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $85dae4facaf44a93$export$d0a45ab59b4606b extends (0, $lSL6v.MediaFilePreviewError) {
    constructor(source){
        super($85dae4facaf44a93$var$getImageLoadPrimaryReason(source));
    }
}
module.exports["ImageLoadError"] = $85dae4facaf44a93$export$d0a45ab59b4606b;

});

parcelRegister("lSL6v", function(module, exports) {
class $908e828479bf148b$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
module.exports["MediaFilePreviewError"] = $908e828479bf148b$export$96e559194c287cf4;

});

parcelRegister("f6g62", function(module, exports) {
/** Verifies if the current screen is retina display */ function $6bbe2f22848e73bc$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $6bbe2f22848e73bc$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $6bbe2f22848e73bc$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
module.exports["createRequestDimensions"] = $6bbe2f22848e73bc$export$3063221e86a58f9;

});

parcelRegister("dpCBK", function(module, exports) {

var $cTpcF = parcelRequire("cTpcF");


var $lSL6v = parcelRequire("lSL6v");

const $9dcef4ea458aecb7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ((0, $cTpcF.isMediaFilePreviewError)(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new (0, $lSL6v.MediaFilePreviewError)(primaryReason, error.secondaryError);
        return error;
    }
    return new (0, $lSL6v.MediaFilePreviewError)(primaryReason, error);
};
module.exports["ensureMediaFilePreviewError"] = $9dcef4ea458aecb7$export$7156ce7b78b49bd7;

});

parcelRegister("cTpcF", function(module, exports) {

var $lSL6v = parcelRequire("lSL6v");

function $9ab9ea1317bdc7b4$export$553696a6e769784c(err) {
    return err instanceof (0, $lSL6v.MediaFilePreviewError);
}
module.exports["isMediaFilePreviewError"] = $9ab9ea1317bdc7b4$export$553696a6e769784c;

});

parcelRegister("a0nKQ", function(module, exports) {

var $gOw2P = parcelRequire("gOw2P");


var $aykCQ = parcelRequire("aykCQ");

const $017d76cb8cfc0c2c$export$b7e8ee3f7a41459 = new (0, $gOw2P.CardPreviewCacheImpl)((0, $aykCQ.createObjectURLCache)());
module.exports["mediaFilePreviewCache"] = $017d76cb8cfc0c2c$export$b7e8ee3f7a41459;

});

parcelRegister("gOw2P", function(module, exports) {

var $hA5aq = parcelRequire("hA5aq");

class $866f4dfa6d635d66$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = (0, $hA5aq.getCacheKey)(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = (0, $hA5aq.getCacheKey)(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = (0, $hA5aq.getCacheKey)(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = (0, $hA5aq.getCacheKey)(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = (0, $hA5aq.getCacheKey)(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}
module.exports["CardPreviewCacheImpl"] = $866f4dfa6d635d66$export$7b50526c091bb915;

});

parcelRegister("hA5aq", function(module, exports) {
const $9fa31886e4bdb966$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
module.exports["getCacheKey"] = $9fa31886e4bdb966$export$611736262b635f8d;

});

parcelRegister("aykCQ", function(module, exports) {

var $jx0Wk = parcelRequire("jx0Wk");


var $9yzL6 = parcelRequire("9yzL6");

const $f5712eaed54f777e$export$ba71be67d5c32535 = ()=>new (0, $9yzL6.ObjectURLCache)((0, $jx0Wk.PREVIEW_CACHE_LRU_SIZE));
module.exports["createObjectURLCache"] = $f5712eaed54f777e$export$ba71be67d5c32535;

});

parcelRegister("jx0Wk", function(module, exports) {
const $ff738ace400485a0$export$36d0f9859761643d = 50;
module.exports["PREVIEW_CACHE_LRU_SIZE"] = $ff738ace400485a0$export$36d0f9859761643d;

});

parcelRegister("9yzL6", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * The oldest entry is kept if `shouldEvict` returns false.
 */ class $a973011e4834b8ce$var$EvictionLRUCache extends (0, $lPEt0.LRUMap) {
    shift() {
        const oldest = this.oldest;
        if (oldest && this.shouldEvict && !this.shouldEvict([
            oldest.key,
            oldest.value
        ])) return undefined;
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = void 0;
        this.onEvict = void 0;
        this.shouldEvict = options?.shouldEvict;
        this.onEvict = options?.onEvict;
    }
}
class $a973011e4834b8ce$export$75d1c8c9ba1d0773 {
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = removed?.dataURI.split('#')[0];
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
    constructor(size){
        this.cache = void 0;
        this.activeRefs = new Map();
        this.cache = new $a973011e4834b8ce$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = entry[1].dataURI.split('#')[0];
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
}
module.exports["ObjectURLCache"] = $a973011e4834b8ce$export$75d1c8c9ba1d0773;

});

parcelRegister("2j3QG", function(module, exports) {

var $9d5qf = parcelRequire("9d5qf");


var $3xQMT = parcelRequire("3xQMT");


var $5SJAV = parcelRequire("5SJAV");

const $3ad06c6448a88291$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $5SJAV.getLocalPreview)(filePreview),
        (0, $9d5qf.enrichAttrsWithClientId)(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return (0, $3xQMT.extendAndCachePreview)(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
module.exports["getAndCacheLocalPreview"] = $3ad06c6448a88291$export$98e935d981c884d;

});

parcelRegister("9d5qf", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $iaM1g = parcelRequire("iaM1g");

const $cc83c9f3ff96b074$export$9c3033a429726afd = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return (0, $iaM1g.mergeClientIdIntoAttrs)(clientId, id, mediaBlobUrlAttrs, collectionName);
};
module.exports["enrichAttrsWithClientId"] = $cc83c9f3ff96b074$export$9c3033a429726afd;

});

parcelRegister("iaM1g", function(module, exports) {
const $f10cb5cb61ffd530$export$95365db502f725a1 = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};
module.exports["mergeClientIdIntoAttrs"] = $f10cb5cb61ffd530$export$95365db502f725a1;

});

parcelRegister("3xQMT", function(module, exports) {

var $4bGyn = parcelRequire("4bGyn");


var $a0nKQ = parcelRequire("a0nKQ");

const $5ce17a9a68fa566f$export$f47ee10612bdcb19 = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $4bGyn.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $a0nKQ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
module.exports["extendAndCachePreview"] = $5ce17a9a68fa566f$export$f47ee10612bdcb19;

});

parcelRegister("5SJAV", function(module, exports) {

var $nfEzS = parcelRequire("nfEzS");


var $3e8oF = parcelRequire("3e8oF");


var $tl7fg = parcelRequire("tl7fg");


var $599Ht = parcelRequire("599Ht");

const $a0bd8710dea806c3$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $3e8oF.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $tl7fg.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $a0bd8710dea806c3$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $599Ht.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $tl7fg.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $a0bd8710dea806c3$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $tl7fg.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $nfEzS.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $a0bd8710dea806c3$var$getImageLocalPreview(value);
            case 'video':
                return $a0bd8710dea806c3$var$getVideoLocalPreview(value);
            default:
                throw new (0, $tl7fg.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $tl7fg.LocalPreviewError)('local-preview-unsupported');
};
module.exports["getLocalPreview"] = $a0bd8710dea806c3$export$3d6ed68e437b8c99;

});

parcelRegister("tl7fg", function(module, exports) {

var $lSL6v = parcelRequire("lSL6v");

class $4e9501cbfd1f1c46$export$2c035820a31723e extends (0, $lSL6v.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
module.exports["LocalPreviewError"] = $4e9501cbfd1f1c46$export$2c035820a31723e;

});

parcelRegister("599Ht", function(module, exports) {
const $e9eb3851d008a755$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["takeSnapshot"] = $e9eb3851d008a755$export$4269d30173168e5c;

});

parcelRegister("bhs8k", function(module, exports) {

var $9d5qf = parcelRequire("9d5qf");


var $3xQMT = parcelRequire("3xQMT");


var $jV5Ze = parcelRequire("jV5Ze");

const $9e57569421b824bb$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $jV5Ze.getRemotePreview)(mediaClient, id, params, traceContext),
        (0, $9d5qf.enrichAttrsWithClientId)(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return (0, $3xQMT.extendAndCachePreview)(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
module.exports["getAndCacheRemotePreview"] = $9e57569421b824bb$export$49721bcc26fb9388;

});

parcelRegister("jV5Ze", function(module, exports) {

var $6zjhP = parcelRequire("6zjhP");

const $94b7e32c5e6d1447$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $6zjhP.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};
module.exports["getRemotePreview"] = $94b7e32c5e6d1447$export$bfe20bd01db02b3;

});

parcelRegister("6zjhP", function(module, exports) {

var $lSL6v = parcelRequire("lSL6v");

class $8a38c312d277f751$export$10ab445310d30114 extends (0, $lSL6v.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
module.exports["RemotePreviewError"] = $8a38c312d277f751$export$10ab445310d30114;

});

parcelRegister("fBaII", function(module, exports) {

var $4bGyn = parcelRequire("4bGyn");


var $iDrrr = parcelRequire("iDrrr");


var $jlUVx = parcelRequire("jlUVx");


var $iaM1g = parcelRequire("iaM1g");

const $5e0ed3a5f93fadac$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs, seededCdnUrl)=>{
    const signedDataURI = mediaClient.getImageUrlSync(id, params, seededCdnUrl);
    return mediaBlobUrlAttrs ? (0, $4bGyn.addFileAttrsToUrl)(signedDataURI, mediaBlobUrlAttrs) : signedDataURI;
};
const $5e0ed3a5f93fadac$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs, seededCdnUrl)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $iDrrr.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = (0, $iaM1g.mergeClientIdIntoAttrs)(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $5e0ed3a5f93fadac$var$getDataUri(mediaClient, id, params, attrsWithClientId, seededCdnUrl);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $5e0ed3a5f93fadac$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId, seededCdnUrl);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $jlUVx.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
module.exports["getSSRPreview"] = $5e0ed3a5f93fadac$export$faf1c301c59a1bdc;

});

parcelRegister("jlUVx", function(module, exports) {

var $lSL6v = parcelRequire("lSL6v");

class $046c3713c6dbe9ce$export$18e89b7e50818288 extends (0, $lSL6v.MediaFilePreviewError) {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
module.exports["SsrPreviewError"] = $046c3713c6dbe9ce$export$18e89b7e50818288;

});

parcelRegister("550mF", function(module, exports) {
const $c199bfb68db680f9$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
module.exports["isLocalPreview"] = $c199bfb68db680f9$export$78ad02c5efc361c9;

});

parcelRegister("27snD", function(module, exports) {
const $19c60d48b79e9b7c$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
module.exports["isRemotePreview"] = $19c60d48b79e9b7c$export$87442a14a8a19e0;

});

parcelRegister("9GwDf", function(module, exports) {
const $d510c64fc6c8dc04$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
module.exports["isSSRClientPreview"] = $d510c64fc6c8dc04$export$36aae1afbc0a9661;

});

parcelRegister("japih", function(module, exports) {
const $94c9b82e6eb8aaf8$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
module.exports["isSSRDataPreview"] = $94c9b82e6eb8aaf8$export$f366c2c8a792cce6;

});

parcelRegister("aw7FB", function(module, exports) {
const $1b0050b635bf422a$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
module.exports["isSSRPreview"] = $1b0050b635bf422a$export$dea79d05143ccf4;

});

parcelRegister("lc10g", function(module, exports) {
const $f42f9728f39ad830$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
module.exports["isSupportedLocalPreview"] = $f42f9728f39ad830$export$1fa85b75e8662d54;

});

parcelRegister("9JswH", function(module, exports) {

var $gzVb5 = parcelRequire("gzVb5");


var $l32w2 = parcelRequire("l32w2");

const $6fb1b9af2c2f3e8b$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = (0, $gzVb5.getKey)(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: (0, $l32w2.MAX_EAGER_LOAD_COUNT)
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $6fb1b9af2c2f3e8b$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $6fb1b9af2c2f3e8b$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });
module.exports["generateScriptProps"] = $6fb1b9af2c2f3e8b$export$de7c49925e44d75d;

});

parcelRegister("gzVb5", function(module, exports) {
const $44887fae06c942b0$var$dashed = (param)=>param ? `-${param}` : '';
const $44887fae06c942b0$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$44887fae06c942b0$var$dashed(collectionName)}${$44887fae06c942b0$var$dashed(occurrenceKey)}${$44887fae06c942b0$var$dashed(resizeMode)}`;
module.exports["getKey"] = $44887fae06c942b0$export$a47fb462a08de82f;

});

parcelRegister("l32w2", function(module, exports) {
const $df091675c0f8d5b7$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $df091675c0f8d5b7$export$d26005e8749921c9 = 'mediaCountSsr';
const $df091675c0f8d5b7$export$7aeb4eab53a57df7 = 'performanceEntries';
const $df091675c0f8d5b7$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $df091675c0f8d5b7$export$4ced612cd8b14538 = 6;
module.exports["MAX_EAGER_LOAD_COUNT"] = $df091675c0f8d5b7$export$4ced612cd8b14538;

});

parcelRegister("a4SEC", function(module, exports) {

var $gzVb5 = parcelRequire("gzVb5");


var $l38bC = parcelRequire("l38bC");

const $b4afaddd3336dcb8$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $l38bC.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $gzVb5.getKey)(identifier, resizeMode)];
};
module.exports["getSSRData"] = $b4afaddd3336dcb8$export$d3a890b0f7844b6f;

});

parcelRegister("l38bC", function(module, exports) {

var $cE1PN = parcelRequire("cE1PN");

function $293d54785056f227$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = (0, $cE1PN.getMediaGlobalScope)(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
module.exports["getMediaCardSSR"] = $293d54785056f227$export$ede93d4564eaa8da;

});

parcelRegister("cE1PN", function(module, exports) {
function $1210b9fd65acfc17$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
module.exports["getMediaGlobalScope"] = $1210b9fd65acfc17$export$96a3cfb3a41e9bb2;

});

parcelRegister("cLvvT", function(module, exports) {
const $3f01a19d0b5bebb7$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
module.exports["isBigger"] = $3f01a19d0b5bebb7$export$912a00e9a5470d9a;

});

parcelRegister("eKuIE", function(module, exports) {
const $6caed2620744a748$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = current?.width || 0;
    const nextWidth = next?.width || 0;
    return currentWidth < nextWidth;
};
module.exports["isWider"] = $6caed2620744a748$export$ae6224430098bc5f;

});

parcelRegister("fioVE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $e5f5227f3b2f0d05$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["useCurrentValueRef"] = $e5f5227f3b2f0d05$export$b3e10e1f0fbb71db;

});

parcelRegister("iQxQk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $2gopW = parcelRequire("2gopW");

const $e185839fcf3cffd9$export$758a2fef95a29ad0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    let t0;
    if ($[0] !== props.children) {
        t0 = props.children({
            loading: false,
            error: true
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2gopW.MediaImageWithMediaClient), props);
        $[4] = props;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: t1
        }, t2);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2gopW.MediaImageWithMediaClient), props));
module.exports["MediaImageWithErrorBoundary"] = $e185839fcf3cffd9$export$758a2fef95a29ad0;

});

parcelRegister("2gopW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $g0fSg = parcelRequire("g0fSg");


var $9vt4W = parcelRequire("9vt4W");


var $iDrrr = parcelRequire("iDrrr");

const $67c41173d305abe8$var$copyDivStyles = null;
const $67c41173d305abe8$var$MediaImageBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { identifier: identifier, apiConfig: t1, children: children, ssr: ssr } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const apiConfig = t2;
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, "max-age": maxAge } = apiConfig;
    let t3;
    if ($[2] !== height || $[3] !== width) {
        t3 = {
            width: width,
            height: height
        };
        $[2] = height;
        $[3] = width;
        $[4] = t3;
    } else t3 = $[4];
    const dimensions = t3;
    let t4;
    if ($[5] !== allowAnimated || $[6] !== dimensions || $[7] !== identifier || $[8] !== maxAge || $[9] !== mode || $[10] !== ssr || $[11] !== upscale) {
        t4 = {
            identifier: identifier,
            dimensions: dimensions,
            ssr: ssr,
            resizeMode: mode,
            allowAnimated: allowAnimated,
            upscale: upscale,
            maxAge: maxAge
        };
        $[5] = allowAnimated;
        $[6] = dimensions;
        $[7] = identifier;
        $[8] = maxAge;
        $[9] = mode;
        $[10] = ssr;
        $[11] = upscale;
        $[12] = t4;
    } else t4 = $[12];
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $9vt4W.useFilePreview)(t4);
    let status = "loading";
    if (preview?.dataURI) status = "succeeded";
    else if (error) status = "error";
    const t5 = status === "loading";
    const t6 = status === "error";
    let t7;
    if ($[13] !== children || $[14] !== preview?.dataURI || $[15] !== status || $[16] !== t5 || $[17] !== t6) {
        t7 = children({
            loading: t5,
            error: t6,
            data: status === "succeeded" ? {
                status: status,
                src: preview?.dataURI
            } : undefined
        });
        $[13] = children;
        $[14] = preview?.dataURI;
        $[15] = status;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== copyNodeRef) {
        t8 = (0, $iDrrr.fg)("platform_media_cross_client_copy") && /*#__PURE__*/ $cozmU.createElement("div", {
            ref: copyNodeRef,
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        });
        $[19] = copyNodeRef;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== getSsrScriptProps) {
        t9 = getSsrScriptProps && /*#__PURE__*/ $cozmU.createElement("script", getSsrScriptProps());
        $[21] = getSsrScriptProps;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, t7, t8, t9);
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    return t10;
} : ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $9vt4W.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), (0, $iDrrr.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $cozmU.createElement("div", {
        ref: copyNodeRef,
        className: (0, $hekY6.default)([
            "_3iDTPbYbGa"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $cozmU.createElement("script", getSsrScriptProps()));
};
const $67c41173d305abe8$export$8acd7eecc88dfeb5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $g0fSg.withMediaClient)($67c41173d305abe8$var$MediaImageBase);
        $[0] = t0;
    } else t0 = $[0];
    const MediaImageComponent = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement(MediaImageComponent, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    const MediaImageComponent = (0, $cozmU.useMemo)(()=>(0, $g0fSg.withMediaClient)($67c41173d305abe8$var$MediaImageBase), []);
    return /*#__PURE__*/ $cozmU.createElement(MediaImageComponent, props);
};
module.exports["MediaImageWithMediaClient"] = $67c41173d305abe8$export$8acd7eecc88dfeb5;

});


//# sourceMappingURL=cardWithMediaClient.5125fddc.js.map
